import React from 'react';

import {
  FooterLinkDto,
  FooterLinkViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { FooterLinkFormValue } from '../types';
import { buildDefaultUpdateFormValues, buildDto } from '../utils/mappers';

import ModalEdition from './ModalEdition';

interface ModalUpdateProps {
  footerLink: FooterLinkDto;
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalUpdate({
  footerLink,
  close,
  visible,
  refreshDashboard,
}: ModalUpdateProps): React.ReactElement {
  const initials: FooterLinkFormValue =
    buildDefaultUpdateFormValues(footerLink);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: FooterLinkFormValue) =>
      AdminFonctionnelControllerApi.updateFooterLinkUsingPUT(
        footerLink.idCorrelation,
        buildDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: FooterLinkViolationDtoFormFieldEnum, values: FooterLinkFormValue) =>
      AdminFonctionnelControllerApi.validateUpdateFooterLinkFieldUsingPOST(
        field,
        footerLink.idCorrelation,
        buildDto(values),
      ),
    response => response.footerLinkViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Mise à jour du lien"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
